import { useEffect, useState } from "@bestowinc/tinkertoy-shell-deps/react";

/** How long a client navigation may run before the loading module shows. */
export const LOADING_DELAY_MS = 300;

/**
 * `true` once `active` has stayed `true` for `delayMs`; drops to `false` as
 * soon as `active` does. The timer depends only on the boolean, so changes
 * that keep `active` true (e.g. a redirect hop) don't restart it.
 */
export function useDelayedFlag(active: boolean, delayMs: number): boolean {
  const [elapsed, setElapsed] = useState(false);

  useEffect(() => {
    if (!active) {
      setElapsed(false);
      return;
    }
    const timer = setTimeout(() => setElapsed(true), delayMs);
    return () => {
      clearTimeout(timer);
    };
  }, [active, delayMs]);

  return active && elapsed;
}
